import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faQuidditch,
  faSpiderBlackWidow,
  faTriangle,
  faCrosshairs,
  faExchangeAlt,
} from '@fortawesome/pro-duotone-svg-icons';
import { TabPaneKey } from '../OpsCenterView';
import OpsCenterLink from '../OpsCenterLink';
import routes from 'src/routes';
import styles from '../OpsCenterView.module.less';

export namespace DataCleansingTab {
  export const key = '/nucleus/dataCleansing' satisfies TabPaneKey;

  export const header = (
    <>
      <FontAwesomeIcon icon={faQuidditch} /> Data Cleansing
    </>
  );
  type ContentProps = {
    isRaSpiderCleanup: boolean | null;
    isRaShallowCleanup: boolean | null;
    isRaProductCleanup: boolean | null;
    isRaDataCleanup: boolean | null;
  };
  export const Content: React.FC<ContentProps> = ({
    isRaSpiderCleanup,
    isRaShallowCleanup,
    isRaProductCleanup,
    isRaDataCleanup,
  }) => {
    return (
      <>
        {isRaSpiderCleanup && (
          <OpsCenterLink to={routes.spiderCleanUp} icon={faSpiderBlackWidow}>
            Spider Cleanup
          </OpsCenterLink>
        )}
        {isRaShallowCleanup && (
          <OpsCenterLink to={routes.shallowCleanUp} icon={faTriangle} iconClassName={styles.opsCenterShallowIcon}>
            Shallow Cleanup
          </OpsCenterLink>
        )}
        {isRaProductCleanup && (
          <OpsCenterLink to={routes.productCleanUp} icon={faCrosshairs}>
            Product Cleanup
          </OpsCenterLink>
        )}
        {isRaDataCleanup && (
          <OpsCenterLink to={routes.dataCleanUp} icon={faExchangeAlt}>
            Data Cleanup
          </OpsCenterLink>
        )}
      </>
    );
  };
}
